import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

// POST/GET/DELETE /tokens is registered at the v2 prefix on the backend
// (`app.register(personalAccessTokenRoutes, { prefix: '/api/v2' })`), while
// REACT_APP_API_URL is the v1 base every other service here defaults to
// (see e.g. src/redux/tasks/actions.js, src/redux/state-areas/reports/actions.js
// for the same `.replace('/api/v1', '/api/v2')` pattern used for v2 endpoints).
const v2BaseUrl = process.env.REACT_APP_API_URL?.replace('/api/v1', '/api/v2');

export const personalAccessTokensApi = createApi({
  reducerPath: 'personalAccessTokensApi',
  baseQuery: fetchBaseQuery({
    baseUrl: v2BaseUrl,
    prepareHeaders: (headers) => {
      const token = localStorage.getItem('token');
      if (token) headers.set('Authorization', `Bearer ${token}`);
      headers.set('Content-Type', 'application/json');
      return headers;
    },
  }),
  tagTypes: ['PersonalAccessTokens'],
  keepUnusedDataFor: 300,
  endpoints: (builder) => ({
    listTokens: builder.query({
      query: () => ({
        url: '/tokens',
        method: 'GET',
      }),
      providesTags: ['PersonalAccessTokens'],
    }),
    createToken: builder.mutation({
      query: (body) => ({
        url: '/tokens',
        method: 'POST',
        body,
      }),
      invalidatesTags: ['PersonalAccessTokens'],
    }),
    revokeToken: builder.mutation({
      query: (id) => ({
        url: `/tokens/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['PersonalAccessTokens'],
    }),
  }),
});

export const {
  useListTokensQuery,
  useCreateTokenMutation,
  useRevokeTokenMutation,
} = personalAccessTokensApi;
